export enum EsriTheme {
  Dark = 'arcgis-dark-gray',
  Light = 'arcgis-light-gray',
  Streets = 'arcgis-imagery',
}
